import type { WorkflowDocument } from './workflow-types';
import type { MatterFile } from '@/lib/services/files/types';

/**
 * Map WorkflowDocument(s) back to the {@link MatterFile} shape the shared
 * `AddDocument` choose-existing picker consumes. `WorkflowDocument` is a
 * near-superset, so this is a straight field copy — used by workflow surfaces
 * (notifications send card, discovery draft editor) that hold their pickable set
 * as `WorkflowDocument[]` but now attach through `AddDocument` (LF-6189). The
 * inverse of `convertDocumentsToWorkflowFormat`.
 */
export function workflowDocumentsToMatterFiles(
  docs: WorkflowDocument[]
): MatterFile[] {
  return docs.map((d) => ({
    id: d.id,
    originalFilename: d.originalFilename,
    displayName: d.displayName,
    status: d.status as MatterFile['status'],
    s3Key: d.s3Key,
    imageS3Key: d.imageS3Key ?? undefined,
    imageMimeType: d.imageMimeType,
    mimeType: d.mimeType,
    fileSizeKb: d.fileSizeKb ?? undefined,
    fileType: d.fileType,
    extractedData:
      (d.extractedData as Record<string, unknown> | null) ?? undefined,
    isCertifiedCopy: d.isCertifiedCopy,
    createdAt: d.createdAt,
    updatedAt: d.updatedAt,
    deletedAt: d.deletedAt,
    metadata: (d.metadata as Record<string, unknown> | null) ?? undefined,
    analysisMetadata:
      (d.analysisMetadata as Record<string, unknown> | null) ?? undefined
  }));
}
